// ======================================================================================================================= 1
// gsap.to('.co-home-1-image', {
//     scrollTrigger: {
//         // markers: true,
//         trigger: '.co-home-1',
//         start: 'top top',
//         end: 'bottom top',
//         scrub: 1.25
//     },
//     top: '-20%'
// });
// ======================================================================================================================= 2
gsap.to('.co-home-2-image', {
    scrollTrigger: {
        trigger: '.co-home-2-text',
        endTrigger: '.co-home-2',
        start: 'bottom bottom',
        end: 'bottom bottom',
        scrub: 1.5
    },
    scale: 1
});
// ======================================================================================================================= 6
// gsap.to('.co-home-6-video-layer-1', {
//     scrollTrigger: {
//         // markers: true,
//         trigger: '.co-home-6-video',
//         start: 'bottom bottom',
//         end: 'top top',
//         scrub: 1.5
//     },
//     width: '100%'
// });
// ======================================================================================================================= 9 BEE
gsap.registerPlugin(MotionPathPlugin);

const coH7ScrollTRIGGER = '.co-home-9-bee-trigger';
const coH7ScrollTRIGGEREND = '.co-home-9';
const coH7ScrollSTART = 'top bottom';
const coH7ScrollEND = 'bottom top';

function getUpdatedMotionPath() {
  return {
    markers: true,
    immediateRender: true,
    path: "#co-svg-home-9-motion-path-id",
    align: "#co-svg-home-9-motion-path-id",
    alignOrigin: [0.5, 0.5],
    start: 0,
    end: 1,
  };
}

function coMotionPathFlipRight() {
  gsap.to(".co-home-9-bee-layer-2", { rotateY: 0, duration: 0.1 });
}

function coMotionPathFlipLeft() {
  gsap.to(".co-home-9-bee-layer-2", { rotateY: 180, duration: 0.1 });
}

ScrollTrigger.matchMedia({
  "(min-width: 750px)": function () {
    gsap.set('.co-home-9-bee-layer-1', { rotateX: 360, opacity: 1 });

    const tl = gsap.timeline({
      defaults: { duration: 1, ease: 'none' },
      scrollTrigger: {
        trigger: coH7ScrollTRIGGER,
        endTrigger: coH7ScrollTRIGGEREND,
        start: coH7ScrollSTART,
        end: coH7ScrollEND,
        scrub: 1,
      },
    });

    tl.to('.co-home-9-bee', {
      motionPath: getUpdatedMotionPath(),
    });

    ScrollTrigger.create({
      trigger: coH7ScrollTRIGGER,
      endTrigger: coH7ScrollTRIGGEREND,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      onUpdate: (self) => {
        self.direction === -1 ? coMotionPathFlipLeft() : coMotionPathFlipRight();
      },
    });
  },
});
// ======================================================================================================================= 9 TICKER
(function() {
  const tickerConfig = {
    parent: ".co-home-9-ticker-number",
    startValue: 0,
    duration: 7,
    ease: "power2.out",
    decimals: 0,
    prefix: "",
    suffix: "",
    useCommas: false,
    selector: ".co-home-9-ticker-number-target",
    // ScrollTrigger
    start: "top 80%",
    end: "bottom top",
    markers: false,
  };

  // === TICKER FUNCTION ===
  function initTickers(config = tickerConfig) {
    const parent = document.querySelector(config.parent);
    if (!parent) return;

    const elements = parent.querySelectorAll(config.selector);
    if (!elements.length) return;

    elements.forEach((el) => {
      const endValue = parseFloat(el.dataset.value) || 0;
      const obj = { value: config.startValue };

      gsap.to(obj, {
        value: endValue,
        duration: config.duration,
        ease: config.ease,
        scrollTrigger: {
          trigger: el,
          start: config.start,
          end: config.end,
          markers: config.markers,
          toggleActions: "play none none none",
        },
        onUpdate() {
          let display = obj.value.toFixed(config.decimals);
          if (config.useCommas) {
            display = parseFloat(display).toLocaleString("en-US", {
              minimumFractionDigits: config.decimals,
              maximumFractionDigits: config.decimals,
            });
          }
          el.textContent = config.prefix + display + config.suffix;
        },
      });
    });
  }

  // === INIT ===
  initTickers();
})();
// ======================================================================================================================= 10
